/**
* @Author: Daniel Rhees <Daniel>
* @Date:   2017-02-13T10:18:00-08:00
* @Email:  daniel@reflexmedia.com
 * @Last modified by:   Daniel
 * @Last modified time: 2017-04-12T10:58:41-07:00
*/



import React, { Component } from 'react';
import glamorous, { Div } from 'glamorous';
import { type, textColor, spacing, borders } from '../../style';

const sizeStyles = {
  SM: {
    padding: '48px 22px'
  }
};

const title = {
  SM: {
    ...type.title.XS,
  },

  NORMAL: {
    fontSize: '32px'
  }
};

const bordered = {
  borderRadius: 3,
  border: borders.DARKER,
  borderWidth: 2,
  borderStyle: 'dashed'
};

const Container = glamorous.div({
  padding: '120px 22px'
}, ({withBorder, size}) => {
  const borderStyles = withBorder ? bordered : {};
  const sizeStyle = size ? sizeStyles[size] : {};

  return [borderStyles, sizeStyle];
});

const Content = glamorous.div({
  textAlign: 'center',
  ...textColor.NORMAL
});

const Title = glamorous.div({
  ...textColor.DARKER,
  ...spacing.MARGIN_BOTTOM_SM
}, ({size}) => {
  return [title[size]];
});

const BlankSlate = (props) => {
    const {
      title,
      message,
      size,
      bordered,
      ...rest
    } = props;

    return (
      <Container withBorder={bordered} size={size}>
          <Content>
            <Title size={size || 'NORMAL'}>{title || 'Not found'}</Title>
            <Div fontSize={'28px'}>
              {message}
            </Div>
          </Content>
      </Container>
    );
  }

export default BlankSlate;



// WEBPACK FOOTER //
// ./src/components/blocks/BlankSlate.jsx